import type { Datacenter } from '../types/datacenter';
import { DatacenterId } from '../enums/datacenter-id';

export const datacenters: Datacenter[] = [
  {
    id: DatacenterId.USOregon,
    name: 'US - Oregon',
  },
  {
    id: DatacenterId.EUFrankfurt,
    name: 'EU - Frankfurt',
  },
  {
    id: DatacenterId.EUIreland,
    name: 'EU - Ireland',
  },
  {
    id: DatacenterId.APACSingapore,
    name: 'APAC - Singapore',
  },
  {
    id: DatacenterId.SASaoPaulo,
    name: 'SA - Sao Paulo',
  },
  {
    id: DatacenterId.APACSydney,
    name: 'APAC - Sydney',
  },
];
